<template>
    <b-card no-body>
        <b-card-header class="border-0 domain-table-headers">
            <div v-if="categoriesLoading">
                <h3>Loading...</h3>
            </div>
            <div v-else class="domain-filters">
                <base-input label="Name" placeholder="Name" v-model="filters.name__icontains" />
                <base-input label="Domain address" placeholder="Domain address" v-model="filters.domain_address__icontains" />
                <base-input label="Category">
                    <b-dropdown variant="outline-light" :text="categories[filters.category]">
                        <b-dropdown-item v-for="(category,index) in categories" v-bind:key="index" @click="filters.category=index">{{category}}</b-dropdown-item>
                    </b-dropdown>
                </base-input>
                <base-input label="Active status">
                    <b-dropdown variant="outline-light" :text="activeStatuses[filters.is_active]">
                        <b-dropdown-item v-for="(status,index) in activeStatuses" v-bind:key="'activestatus_'+index" @click="filters.is_active=index">{{status}}</b-dropdown-item>
                    </b-dropdown>
                </base-input>
            </div>
            
            <router-link :to="'/domain/new'" class="d-flex align-items-center">
                <base-button icon type="info" class="btn btn-info">
                    <span class="btn-inner--icon">
                        <i class="ni ni-fat-add"/>
                    </span>
                </base-button>
            </router-link>
        </b-card-header>
        <card v-if="isLoading || categoriesLoading">
            <h4>Loading...</h4>
        </card>
        <el-table v-else
                  class="table-responsive table"
                  header-row-class-name="thead-light"
                  :data="domains">
            <el-table-column label="ID" prop="id" min-width="50px" />
            <el-table-column label="Name" prop="name" />

            <el-table-column label="Domain address" prop="domain_address" min-width="180px">
                <template v-slot="{row}">
                    <b-media no-body class="align-items-center">
                        <a :href="row.domain_address" target="_blank">{{row.domain_address}}</a>
                    </b-media>
                </template>
            </el-table-column>

            <el-table-column label="Category" prop="_">
                <template v-slot="{row}">
                    <b-media no-body class="align-items-left">
                        {{categories[row.category]}}
                    </b-media>
                </template>
            </el-table-column>
            
            <el-table-column label="Actions" prop="_">
                <template v-slot="{row}">
                    <b-media no-body class="align-items-center justify-content-end">
                        <router-link v-bind:key="row.id" :to="'/domain/'+row.id">
                            <base-button icon type="info">
                                <span class="btn-inner--icon">
                                    <i class="ni ni-align-center"/>
                                </span>
                            </base-button>
                        </router-link>
                        <base-button icon type="info" @click="runDomainJob(row.id,row.name)">
                            <span class="btn-inner--icon">
                                <i class="ni ni-button-play"/>
                            </span>
                        </base-button>
                    </b-media>
                </template>
            </el-table-column>
        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="10" :total="total" @change="pageChanged">
                <template v-slot:prev-text>
                    <a class="page-link" aria-label="Previous">
                        <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                    </a>
                </template>
            </base-pagination>
        </b-card-footer>
    </b-card>
</template>

<script>
import {Table,TableColumn} from 'element-ui'

import RepositoryFactory from "@/repositories/RepositoryFactory"

const DomainRepository = RepositoryFactory.get('domain')
const DomainCategoryRepository = RepositoryFactory.get('domain_category')
const JobSchedulerRepository = RepositoryFactory.get('job_scheduler')

export default {
    name:'domain-table',

    components:{
        [Table.name]:Table,
        [TableColumn.name]:TableColumn,
    },
    created(){
        this.getPage(this.currentPage);
        DomainCategoryRepository.get().then((response) => {
            var categoryList = response.data;
            this.categories={null:'No category',undefined:'Not selected'}
            for(var i in categoryList){
                var category = categoryList[i]
                this.categories[category.id] = category.name;
            }
            this.categoriesLoading=false;
        })
    },
    data(){
        return {
            currentPage: 1,
            total:0,
            domains:null,
            lastRequestTimestamp:0,

            filters:{category:undefined, is_active:'True'},
            activeStatuses:{'True':'Active','False':'Inactive',undefined:'Active/Inactive'},
            filterTimer:undefined, // Filtre her inputta değil kullanıcı yazmayı bıraktığında çalışsın diye

            categoriesLoading:true,
            categories:null,

            isLoading:true,
        }
    },
    watch:{
        filters:{
            handler(oldVal,newVal){
                clearTimeout(this.filterTimer);
                this.isLoading=true;
                for(var i in this.filters){
                    if(this.filters[i]==="")
                        delete this.filters[i]
                    }
                this.filterTimer=setTimeout(() => this.filterTable(), 1000);
            },
            deep:true,
        }
    },
    methods:{
        getPage(pageNumber){
            var timestamp=Date.now();
            this.lastRequestTimestamp=timestamp;

            this.isLoading=true;
            this.currentPage=pageNumber
            DomainRepository.getTable(pageNumber,this.copyObject(this.filters)).then((response)=> {
                if(this.lastRequestTimestamp!==timestamp) return;
                
                var r=response.data
                
                this.domains=r.results;
                this.total=r.count;
                this.currentPage=pageNumber
                this.isLoading=false;
            });
        },
        pageChanged(pageNumber){
            this.getPage(pageNumber);
        },
        filterTable(){
            this.isLoading=true;
            this.getPage(1);
        },
        runDomainJob(id,name){
            JobSchedulerRepository.runDomain(id).then((response) => {
                this.$notify({
                    message: `Job started for "${name}" Job history ID: ${response.data.job_log_id}`,
                    type: 'success',
                    size: 'lg',
                    timeout: 5000,
                    showClose: true
                });
            })
        }
    }
}
</script>

<style>

.domain-table-headers {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
}

.domain-filters{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap:10px;
}

</style>